import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { IconModule } from '../icon/icon.module';

import { Breadcrumb } from './breadcrumb.component';


@NgModule({
  declarations: [
    Breadcrumb,
  ],
  exports: [
    Breadcrumb,
  ],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
  ]
})
class BreadcrumbModule { }

export {
  BreadcrumbModule,
  Breadcrumb
};
